import { CSSProperties } from "react";
import { getStyle } from "@app/shared/icons/utils";
import { IconStorage } from "@app/shared/icons/interfaces";

export const check: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M12.844-8.11a.74.74 0 0 1 .219.532q-.001.315-.22.531L6.126-.328a.72.72 0 0 1-.531.219.7.7 0 0 1-.531-.22l-3.891-3.89a.7.7 0 0 1-.219-.531.72.72 0 0 1 .219-.531l1.062-1.063a.72.72 0 0 1 .532-.218q.31.001.53.218l2.298 2.297 5.125-5.125a.72.72 0 0 1 .531-.219q.31.001.531.22zm0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(-.953 9.39)"
    />
  ),
  svgProps: {
    height: "9.281",
    width: "12.109",
  }
};

export const checkCircle: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M10.031-6.266a.5.5 0 0 0-.14-.359l-.703-.703a.5.5 0 0 0-.36-.156.45.45 0 0 0-.344.156L5.297-4.156 3.53-5.922a.53.53 0 0 0-.36-.14.47.47 0 0 0-.343.14l-.719.703a.5.5 0 0 0-.14.36q0 .22.14.359l2.829 2.828q.152.14.359.14a.53.53 0 0 0 .36-.14l4.234-4.25a.47.47 0 0 0 .14-.344m1.157-1.75Q11.998-6.64 12-5q-.002 1.628-.812 3.016A5.9 5.9 0 0 1 9.016.188 5.85 5.85 0 0 1 6 1 5.9 5.9 0 0 1 2.984.188 5.95 5.95 0 0 1 .797-1.984 5.95 5.95 0 0 1 0-5a5.91 5.91 0 0 1 2.984-5.187A5.9 5.9 0 0 1 6-11q1.64.001 3.016.813a5.9 5.9 0 0 1 2.172 2.171m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const checkSquare: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="m5.36-1.86 4.796-4.796a.47.47 0 0 0 .14-.344.53.53 0 0 0-.14-.36l-.797-.796A.53.53 0 0 0 9-8.296a.47.47 0 0 0-.344.14L5-4.5 3.36-6.156a.53.53 0 0 0-.36-.14.47.47 0 0 0-.344.14l-.797.797A.5.5 0 0 0 1.703-5q-.002.204.156.344L4.656-1.86A.44.44 0 0 0 5-1.703q.2.002.36-.156M12-8.75v7.5c0 .617-.219 1.14-.656 1.578A2.15 2.15 0 0 1 9.75 1h-7.5A2.18 2.18 0 0 1 .656.328 2.15 2.15 0 0 1 0-1.25v-7.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-11h7.5a2.17 2.17 0 0 1 1.594.656Q12-9.687 12-8.75m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "12",
    width: "12",
  }
};

export const checkSquareOutline: IconStorage = {
  svgCode: (color: string, pathStyle?: CSSProperties) => (
    <path
      d="M11-4.734v2.484q0 .925-.656 1.594A2.17 2.17 0 0 1 8.75 0h-6.5A2.2 2.2 0 0 1 .656-.656 2.2 2.2 0 0 1 0-2.25v-6.5q0-.937.656-1.594A2.2 2.2 0 0 1 2.25-11h6.5q.498 0 .922.188.105.064.14.187a.26.26 0 0 1-.078.219l-.375.39a.25.25 0 0 1-.187.079A1.49 1.49 0 0 0 8.75-10h-6.5q-.515-.001-.89.374c-.243.242-.36.531-.36.875v6.5c0 .344.117.64.36.89.25.243.546.36.89.36h6.5c.344 0 .633-.117.875-.36Q10-1.733 10-2.25v-1.984c0-.07.023-.13.078-.172l.5-.5q.077-.077.172-.078.047.001.094.015a.24.24 0 0 1 .156.235m1.813-3.828-6.36 6.359A.62.62 0 0 1 6-2.016a.6.6 0 0 1-.437-.187l-3.36-3.36A.6.6 0 0 1 2.016-6a.62.62 0 0 1 .187-.453l.86-.86A.6.6 0 0 1 3.5-7.5a.62.62 0 0 1 .453.188L6-5.25l5.063-5.062a.6.6 0 0 1 .437-.188.62.62 0 0 1 .453.188l.86.859A.62.62 0 0 1 13-9a.6.6 0 0 1-.187.438m0 0"
      style={getStyle(color, pathStyle)}
      transform="translate(0 11)"
    />
  ),
  svgProps: {
    height: "11",
    width: "13",
  }
};